import { analyticsAdapter } from "./analyticsAdapter";
import { EventPropertyKeys, EventName } from "./types";

export const isAnalyticsEnabled = (): boolean => {
  return (
    !!process.env.REACT_APP_MIXPANEL_TOKEN &&
    process.env.REACT_APP_MIXPANEL_TRACKER_ENABLED === "true"
  );
};

export const analyticsClient = {
  init: () => {
    if (!isAnalyticsEnabled()) {
      return;
    }

    analyticsAdapter.MixpanelService.init();
  },

  track: (event: EventName, properties: EventPropertyKeys) => {
    if (
      !isAnalyticsEnabled() ||
      !analyticsAdapter.MixpanelService.isInitialized()
    ) {
      return;
    }

    analyticsAdapter.MixpanelService.track(event, properties);
  },
};

